import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb";

const Error404 = () => {
    return (
        <>


            {/* <div className="site-breadcrumb">
                <div className="container">
                    <h2 className="breadcrumb-title">404 Error</h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <a href="index.html">Home</a>
                        </li>
                        <li className="active">404 Error</li>
                    </ul>
                </div>
                <div className="hero-shape">
                    <img 
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"className="hero-shape-1" src="/assets/img/shape/03.svg" alt="" />
                    <img 
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"className="hero-shape-2" src="/assets/img/shape/05.svg" alt="" />
                    <img 
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"className="hero-shape-3" src="/assets/img/shape/06.svg" alt="" />
                    <img 
                    loading="lazy"
                    role="presentation"
                    decoding="async"
                    fetchpriority="high"className="hero-shape-4" src="/assets/img/shape/07.svg" alt="" />
                </div>
            </div> */}
            <Breadcrumb
                title="404 Error"
                path={[
                { label: "Home", href: "/", active: false },
                { label: "404 Error", active: true }
                ]}
            />
            <div class="error-area py-120">
                <div class="container">
                    <div class="col-md-6 mx-auto">
                        <div class="error-wrapper">
                            <h1>4<span>0</span>4</h1>
                            <h2>Opos... Page Not Found!</h2>
                            <p>The page you looking for not found may be it not exist or removed.</p>
                            <Link to="/" class="theme-btn">Go Back Home <i class="far fa-home"></i></Link>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}

export default Error404;